import backend, {WORKFLOW_ENGINE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const queryTasks = async (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${WORKFLOW_ENGINE_API}/task_list?${query}`;
  return backend.get(url);
};

const dedupeTasksByTaskRn = (tasks) => {
  const seenTaskRns = new Set();
  return tasks.filter((task) => {
    const taskRn = task?.taskRn;
    if (!taskRn) {
      return true;
    }
    if (seenTaskRns.has(taskRn)) {
      return false;
    }
    seenTaskRns.add(taskRn);
    return true;
  });
};

const getUserTasks = async (userRn) => {
  const filters = [
    {key: 'principalType', value: 'OWNER'},
    {key: 'principalRn', value: userRn},
  ];
  const response = await queryTasks(filters);
  return response;
};

const getAllTasks = async (startDateInUtc, endDateInUtc) => {
  const startDate = Math.floor(new Date(startDateInUtc).getTime());
  const endDate = Math.floor(new Date(endDateInUtc).getTime());

  const filters = [];
  if (Number.isFinite(startDate) && Number.isFinite(endDate)) {
    filters.push({
      key: 'dueDate',
      value: `[${startDate} TO ${endDate}]`,
    });
  }

  const response = await queryTasks(filters);
  const tasks = dedupeTasksByTaskRn(response?.list || []);
  return {list: tasks};
};

const getTasksByConnection = async (connection) => {
  const filters = [
    {key: 'principalType', value: 'CONNECTION'},
    {key: 'principalRn', value: connection},
  ];
  const response = await queryTasks(filters);
  return response;
};

const addTask = (body) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list/`;
  return backend.post(url, body);
};

const updateTask = (taskRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list/update/${taskRn}`;
  return backend.put(url, body);
};

const removeTask = (taskRn) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list/${taskRn}`;
  return backend.delete(url);
};

const updateTaskStatus = (taskRn, newStatus) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list/update/${taskRn}/status`;
  const body = {status: newStatus};
  return backend.put(url, body);
};

export default {
  addTask,
  updateTask,
  removeTask,
  getUserTasks,
  getAllTasks,
  getTasksByConnection,
  updateTaskStatus,
};
